module.exports = __webpack_public_path__ + "static/media/TBA24-passes-cal.646ad3fb.svg";